ScrollingMediaView = require("../scrolling-media/view")

class TextAndImagesView extends ScrollingMediaView
  serialize: ->
    data = super
    content = []

    for { text, image } in data.content
      if text
        text = written.wrapInTag(text, "p") unless /^<p>/.test(text)
        content.push { content: text, contentType: "text" }
      if image
        content.push { content: image, contentType: "image" }

    data.content = content

    data

module.exports = TextAndImagesView
